<template>
  <div>
    <div class="flex-container">
      <div class="flex-item">
        <img
          class="img-rounded"
          :src="props_userLogoBig"
          width="60"
          height="60"
          :onerror="$defaultUserLog"
        />
      </div>
      <div class="flex-item">
        <textarea
          class="form-control"
          rows="2"
          :placeholder="$t('common.userCommentsItem.placeholder')"
          v-model="commentText"
        ></textarea>
      </div>
      <div class="flex-item">
        <button type="button" class="btn btn-default" @click="submitComment">
          {{$t('common.userCommentsItem.submitComment')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      commentText: "",
    };
  },
  props: {
    props_userLogoBig: { Type: String, default: null, required: true },
  },
  created() {},
  methods: {
    submitComment() {
      this.$emit("submitComment", this.commentText);
      this.commentText = "";
    },
  },
};
</script>

<style scoped>
.form-control {
  margin-left: 5px;
}
.btn {
  margin-left: 5px;
}
.flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.flex-item {
  margin: 2px;
}
.flex-container .flex-item:nth-child(1) {
  flex: 0.2;
}
.flex-container .flex-item:nth-child(2) {
  flex: 3;
}
.flex-container .flex-item:nth-child(3) {
  flex: 1;
}
img {
  width: 60px;
  height: 60px;
  max-width: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/common/userCommentsItem.vue